import { AddressProvider } from 'contexts/AddressContext';
import { CompanyProvider } from 'contexts/CompanyContext';
import { EmployeeProvider } from 'contexts/EmployeeContext';
import { ProviderProvider } from 'contexts/ProviderContext';
import { PreferencesProvider } from 'contexts/PreferencesContext';
import { Switch, Route } from 'react-router-dom';
import LoginPage from './Login';
import PasswordReset from './PasswordReset';
import PrivateRoute from 'routes/PrivateRoute';
import RegisterHandler from './SecuredArea/RegisterArea/RegisterHandler';
import routes from 'config/routes';
import SecuredArea from './SecuredArea';
import SignUpRoute from 'routes/SignUpRoute';
import DefaultModal from '../components/DefaultModal';
import { useEffect, useState } from 'react';
import useWidth from '../hooks/useWidth';
import { Typography } from '@material-ui/core';

function Pages() {
  const width = useWidth();
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (!['lg', 'xl'].includes(width)) {
      setOpenDialog(true);
    } else {
      setOpenDialog(false);
    }
  }, [width]);

  return (
    <>
      <Switch>
        <Route path={routes.login.root}>
          <LoginPage />
        </Route>
        <Route path={routes.passwordReset.root}>
          <PasswordReset />
        </Route>
        <SignUpRoute path={[routes.register.company.root, routes.signup.root]}>
          <RegisterHandler />
        </SignUpRoute>

        <PrivateRoute path={routes.root}>
          <ProviderProvider>
            <CompanyProvider>
              <EmployeeProvider>
                <AddressProvider>
                  <PreferencesProvider>
                    <SecuredArea />
                  </PreferencesProvider>
                </AddressProvider>
              </EmployeeProvider>
            </CompanyProvider>
          </ProviderProvider>
        </PrivateRoute>
      </Switch>
      <DefaultModal open={openDialog} disableScrollLock hideActions onCallback={() => {}} title="Mauvaise Résolution">
        <Typography>
          La résolution actuelle ne permet pas l'affichage de l'application. Veuillez changer l'affichage ou de
          dispositif.
        </Typography>
      </DefaultModal>
    </>
  );
}

export default Pages;
